<template>
  <kst-modal-select
    :class="Info.Dialog.SearchItem.Class"
    :title="Info.Dialog.SearchItem.Title"
    :width="800"
    @init="handleModal_init"
    @submit="handleModal_submit"
  >
    <template #search-result="{ userData }">
      <List
        :items="items"
        :userData="userData"
      />
    </template>
  </kst-modal-select>
</template>

<script>
import Info from "../InvInfo.js";

import List from "./InvScI_List.vue";

/**
 * flow (how to use):
 * 1. handle Init event, set and do show when needed
 * 2. handle Submit event
 */
export default {
  components: {
    List
  },
  props: {
    items: Array
  },
  data: () => ({
    Info: Info,
    selectedRow: null,
    getDetailsService: null,
    // func
    hideFunc: null,
    showFunc: null
  }),
  methods: {
    /*** public method ***/

    show(getDetailsService) {
      this.getDetailsService = getDetailsService;
      this.showFunc();
    },

    /*** by modal ***/

    handleModal_init(show, hide) {
      this.showFunc = show;
      this.hideFunc = hide;

      this.$emit(this.$kst.Enum.Event.Init, this.show);
    },

    handleModal_submit(selected, loadRelated) {
      if (this.getDetailsService) {
        this.selectedRow = selected;
        const config = this.getDetailsService(selected.ID);
        loadRelated(config, this.handleModal_submit_success);
      }
      else {
        this.$emit(this.$kst.Enum.Event.Submit, selected);
        this.hideFunc();
      }
    },
    handleModal_submit_success(data) {
      this.$emit(this.$kst.Enum.Event.Submit, this.selectedRow, data);
      this.hideFunc();
    }
  }
}
</script>